import { render, staticRenderFns } from "./DirectDeletePopup.vue?vue&type=template&id=054253bd"
import script from "./DirectDeletePopup.vue?vue&type=script&lang=js"
export * from "./DirectDeletePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports